(() => {
  const PHONE = '56939501352';
  const PROMPT_DELAY_MS = 15000;
  const PROMPT_SESSION_KEY = 'hrc_whatsapp_prompt_session';

  const pushEvent = (eventName, root, state, placement, trigger = '') => {
    const parameters = {
      product_id: String(root.dataset.productId || ''),
      product_name: root.dataset.productTitle || '',
      variant_id: String(state.variantId || ''),
      variant_name: state.variantTitle === 'Default Title' ? '' : state.variantTitle || '',
      stock_status: state.available ? 'available' : 'sold_out',
      placement,
      trigger,
      measurement_source: 'hrc_theme_whatsapp_experiment',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...parameters,
    });
  };

  const initialize = (root) => {
    if (root.dataset.hrcWaReady === 'true') return;
    root.dataset.hrcWaReady = 'true';

    const productSection = root.closest('[id^="MainProduct-"]') || root.closest('.product') || document;
    const productForm = productSection.querySelector('form[action*="/cart/add"]');
    const purchaseButtons = productSection.querySelector('.product-form__buttons');
    const quantity = productSection.querySelector('.product-form__quantity, [id^="Quantity-Form-"]');
    const inlineLink = root.querySelector('[data-hrc-wa-inline]');
    const inlineLabel = root.querySelector('[data-hrc-wa-inline-label]');
    const note = root.querySelector('[data-hrc-wa-note]');
    const variantsElement = root.querySelector('[data-hrc-wa-variants]');

    if (!inlineLink || !inlineLabel) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsElement?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const state = {
      variantId: Number(root.dataset.variantId || 0),
      variantTitle: root.dataset.variantTitle || '',
      available: root.dataset.variantAvailable === 'true',
    };

    const productUrl = () => {
      const url = new URL(root.dataset.productUrl || window.location.href, window.location.origin);
      if (state.variantId) url.searchParams.set('variant', state.variantId);
      return url.toString();
    };

    const message = () => {
      const variant = state.variantTitle && state.variantTitle !== 'Default Title' ? ` - ${state.variantTitle}` : '';
      const intent = state.available
        ? 'Quisiera ayuda para elegir o comprarlo.'
        : 'Veo que está agotado. Quisiera consultar reposición o una alternativa.';
      return `Hola, estoy viendo ${root.dataset.productTitle}${variant}. ${intent} Enlace: ${productUrl()}`;
    };

    const whatsappUrl = () => `https://wa.me/${PHONE}?text=${encodeURIComponent(message())}`;

    const renderState = () => {
      inlineLink.href = whatsappUrl();
      inlineLabel.textContent = state.available
        ? '¿Necesitas ayuda? Conversar por WhatsApp'
        : 'Consulta cuándo estará disponible';
      inlineLink.setAttribute(
        'aria-label',
        `${state.available ? 'Conversar por WhatsApp sobre' : 'Consultar reposición de'} ${root.dataset.productTitle}`,
      );
      if (note) {
        note.textContent = state.available
          ? 'Te orientamos sobre características, stock y la mejor opción para ti.'
          : 'Pregúntanos por la próxima reposición o por una alternativa disponible.';
      }
      purchaseButtons?.classList.toggle('hrc-wa-control-hidden', !state.available);
      quantity?.classList.toggle('hrc-wa-control-hidden', !state.available);
      root.classList.toggle('hrc-product-whatsapp--sold-out', !state.available);
      root.dataset.stockStatus = state.available ? 'available' : 'sold_out';
    };

    const syncVariant = () => {
      window.setTimeout(() => {
        const input = productForm?.querySelector('input[name="id"]');
        const variantId = Number(input?.value || state.variantId);
        const variant = variants.find((item) => Number(item.id) === variantId);
        if (variant) {
          state.variantId = variant.id;
          state.variantTitle = variant.public_title || variant.title || '';
          state.available = Boolean(variant.available);
        }
        renderState();
        if (!prompt.hidden) promptLink.href = whatsappUrl();
      }, 120);
    };

    inlineLink.addEventListener('click', () => {
      rememberPrompt();
      pushEvent(
        'whatsapp_click',
        root,
        state,
        'product_inline',
        state.available ? 'available_help' : 'sold_out_restock',
      );
    });

    productSection.addEventListener('change', syncVariant);
    document.addEventListener('variant:change', syncVariant);
    renderState();

    const promptKey = PROMPT_SESSION_KEY;
    const prompt = document.createElement('aside');
    prompt.className = 'hrc-whatsapp-prompt';
    prompt.hidden = true;
    prompt.setAttribute('aria-label', 'Ayuda por WhatsApp');
    prompt.setAttribute('aria-live', 'polite');
    prompt.innerHTML = `
      <button class="hrc-whatsapp-prompt__close" type="button" aria-label="Cerrar">×</button>
      <p class="hrc-whatsapp-prompt__title">¿Te ayudamos con este producto?</p>
      <p class="hrc-whatsapp-prompt__text">Podemos orientarte sobre stock, características y la mejor opción para ti.</p>
      <a class="hrc-whatsapp-prompt__link" target="_blank" rel="noopener noreferrer">Conversar por WhatsApp</a>
    `;
    document.body.appendChild(prompt);

    const promptClose = prompt.querySelector('.hrc-whatsapp-prompt__close');
    const promptLink = prompt.querySelector('.hrc-whatsapp-prompt__link');
    const rememberPrompt = () => {
      try {
        window.sessionStorage.setItem(promptKey, '1');
      } catch (error) {
        // The prompt still works when session storage is unavailable.
      }
    };
    const promptWasSeen = () => {
      try {
        return window.sessionStorage.getItem(promptKey) === '1';
      } catch (error) {
        return false;
      }
    };

    promptClose.addEventListener('click', () => {
      prompt.hidden = true;
      rememberPrompt();
    });
    promptLink.addEventListener('click', () => {
      rememberPrompt();
      pushEvent('whatsapp_click', root, state, 'intent_prompt', '15s_after_interaction');
    });

    let engaged = false;
    let engagedVisibleMilliseconds = 0;
    let lastTick = Date.now();
    let promptShown = false;
    const markEngaged = () => {
      if (engaged) return;
      engaged = true;
      lastTick = Date.now();
    };

    productSection.addEventListener('change', markEngaged);
    productSection.addEventListener('click', (event) => {
      if (
        event.target.closest(
          'summary, .product__media, .thumbnail, quantity-input, variant-selects, variant-radios',
        )
      ) {
        markEngaged();
      }
    });
    window.addEventListener(
      'scroll',
      () => {
        const bounds = productSection.getBoundingClientRect();
        if (window.scrollY > 240 && bounds.top < window.innerHeight * 0.7 && bounds.bottom > window.innerHeight * 0.2) {
          markEngaged();
        }
      },
      { passive: true },
    );

    window.setInterval(() => {
      const now = Date.now();
      if (engaged && document.visibilityState === 'visible') {
        engagedVisibleMilliseconds += now - lastTick;
      }
      lastTick = now;
      if (
        !promptShown &&
        !promptWasSeen() &&
        engagedVisibleMilliseconds >= PROMPT_DELAY_MS
      ) {
        promptShown = true;
        promptLink.href = whatsappUrl();
        prompt.hidden = false;
        rememberPrompt();
        pushEvent('whatsapp_prompt_view', root, state, 'intent_prompt', '15s_after_interaction');
      }
    }, 500);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-hrc-wa-root]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
